<template>
	<div :style="{width: width + 'px'}" class="excelBox">
		<table class="table_AgKOv" :style="{'--cow--width': cowWidth + 'px'}">
			<tr v-for="(item, index) in table_list" :key="index">
				<template v-for="(data, da_index) in item">
					<td class="label_3bK48" :key="da_index" v-if="data.type == 'label'||data.type == 'disInput'"
						:colspan="data.colspan" :rowspan="data.rowspan">
						<div v-html="data.value" :style="data.style ? data.style : {}" v-if="!data.fun"
							:class="data.class ? data.class : ''"></div>
						<div v-else :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
							{{data.fun(form,item,index,da_index,data)}}
						</div>

					</td>
					<!-- 输入框 -->
					<td class="value_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'input'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<span>{{ data.value }}</span>

								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 数字输入框 -->
					<td class="value_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'number'">
						<a-form-item>

							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<span>{{ data.value }}</span>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 文本域 -->
					<td class="value_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'textarea'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<!-- <a-textarea v-decorator="[`${filed}_textarea_${index}_${da_index}`, { 
                                                    initialValue: data.value,
                                                    rules: data.rules || []
                                                }]" :rows="data.rows ? data.rows : 1" placeholder="请输入" /> -->

								<span>{{ data.value }}</span>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<td class="value_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'range_time'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<span>{{ data.value }}</span>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 时间选择框 -->
					<td class="value_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'time'">
						<a-form-item>
							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<span v-if="data.before" v-html=' data.before'></span>
								<!-- 需要别的类型可以自己加 -->
								<span v-if='data.showtime'>
									{{ data.value?$moment(data.value).format('HH:mm'):''}}</span>
								<span v-else>{{ data.value }}</span>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 单选下拉框 -->
					<td class="value_1DtKU select_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'select'">
						<!-- <div// :style="data.style ? data.style : {}" :class="data.class ? data.class : ''"> -->
						<!--  -->


						<a-form-item :style="data.style ? data.style : 'display: flex'">
							<span v-if="data.before" v-html=' data.before'></span>
							<div :style="data.field=='line_id'?'flex:1;':data.style"
								:class="data.class ? data.class : ''">
								{{getValue(data.list, data.value)}}

							</div>
						</a-form-item>
					</td>
					<!-- 单选框 -->
					<td class="value_1DtKU select_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'radio'">
						<a-form-item>

							<div :style="data.style ? data.style : {}" :class="data.class ? data.class : ''">
								<!-- 需要别的类型可以自己加 -->
								<span v-if="data.before" v-html=' data.before'></span>
								<a-checkbox disabled v-decorator="[`${filed}_radio_${index}_${da_index}`, { 
                                    initialValue: data.value,
                                    rules: data.rules || []
                                }]">
								</a-checkbox>

								<a-icon type="check-square" v-if='data.value' theme="filled" />
								<a-checkbox v-else>
								</a-checkbox>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 单选框2 -->
					<td class="value_1DtKU select_1DtKU" :key="da_index" :colspan="data.colspan" :rowspan="data.rowspan"
						v-else-if="data.type == 'radio2'">
						<a-form-item>
							<div class="radio_square" :style="data.style ? data.style : {}"
								:class="data.class ? data.class : ''">
								<!-- 需要别的类型可以自己加 -->
								<span v-if="data.before" v-html=' data.before'></span>
								<a-radio-group v-decorator="[`${filed}_radio2_${index}_${da_index}`, { 
                                        initialValue: data.value,
                                        rules: data.rules || []
                                    }]">
									<p v-for="(op,opindex) in data.list" :key="opindex" :value="op.value">
										<a-icon v-if='op.value==data.value' type="check-square" theme="filled" />
										<span v-else
											style='width:12px;height:12px;border:2px solid #999;display: inline-block;'></span>
										{{op.label}}
									</p>
								</a-radio-group>
								<span v-if="data.after">{{ data.after }}</span>
							</div>
						</a-form-item>
					</td>
					<!-- 对角线 -->
					<!--  direction: 'bottom-right' // 可选值: 'bottom-right'(默认), 'top-right', 'bottom-left' -->
					<td class="value_1DtKU diagonal-cell" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'diagonal'">
						<div class="diagonal-wrapper" :ref="`diagonal-${index}-${da_index}`">
							<div class="diagonal-content" :class="data.direction || 'bottom-right'" :data-index="index"
								:data-da-index="da_index">
								<span class="diagonal-text topLeft">{{ data.topLeftText || data.title }}</span>
								<span
									class="diagonal-text bottomRight">{{ data.bottomRightText || data.subtitle }}</span>
							</div>
						</div>
					</td>
					<!-- 嵌套table -->
					<td class="value_1DtKU nested-table-cell" style="padding: 0;height:auto;" :key="da_index" :colspan="data.colspan"
						:rowspan="data.rowspan" v-else-if="data.type == 'table'">
						<div class="nested-table-wrapper">
							<exccelInfo :width="widthHandler(data.colspan)" :table_list="data.table_list"
								:is_add="data.is_add? data.is_add : null" :filed="'table' + da_index + index">
							</exccelInfo>
						</div>
					</td>
				</template>
			</tr>
		</table>
	</div>
</template>

<script>
	import moment from 'moment';
	export default {
		name: 'exccelInfo',
		props: {
			table_list: {
				type: Array,
				default: () => []
			},
			filed: { // 嵌套表格时需要这个来进行校验
				type: String,
				default: ''
			},
			is_add: { // 是否可以新增 max最大新增数量  rawData新增时的数据
				type: [Object, null],
				default: null
			},
			width: {
				type: [Number, String],
				default: 960
			}
		},
		computed: {
			cowWidth() {
				return (this.width / 24).toFixed(5)
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.calculateDiagonals();
			});
		},
		updated() {
			this.$nextTick(() => {
				this.calculateDiagonals();
			});
		},
		methods: {
			getValue(arr, value) {
				let text = ''
				arr.forEach(it => {
					if (it.value == value) {
						text = it.label
					}

				})
				return text
			},
			widthHandler(colspan) {
				return (colspan * this.cowWidth).toFixed(5)
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			/**
			 * 为table类型单元格添加内容
			 * 
			 */
			addNesting() {
				this.table_list.push(this.is_add.rawData)
				// // 触发视图更新
				this.$forceUpdate();
			},
			/**
			 * 删除单元格
			 */
			removeNesting(rowIndex) {
				this.table_list.splice(rowIndex, 1)
			},
			calculateDiagonals() {
				// 查找所有对角线单元格
				const diagonalElements = this.$el.querySelectorAll('.diagonal-content');
				diagonalElements.forEach(element => {
					const parentTd = element.closest('td');
					if (!parentTd) return;

					// 获取单元格的实际尺寸
					const rect = parentTd.getBoundingClientRect();
					const width = parentTd.offsetWidth;
					const height = parentTd.offsetHeight;

					// 计算对角线长度和角度
					const diagonalLength = Math.sqrt(width * width + height * height);
					const angle = Math.atan2(height, width) * 180 / Math.PI;

					// 移除之前添加的样式
					const existingStyle = element.querySelector('.diagonal-line');
					if (existingStyle) {
						existingStyle.remove();
					}

					// 创建样式元素
					const styleElement = document.createElement('style');
					const direction = element.classList.contains('top-right') ? 'top-right' :
						element.classList.contains('bottom-left') ? 'bottom-left' : 'bottom-right';

					let transform = '';
					let transformOrigin = '';

					switch (direction) {
						case 'top-right':
							// 从左下到右上
							transform = `rotate(${-angle}deg)`;
							transformOrigin = '0 100%';
							break;
						case 'bottom-left':
							// 从右上到左下
							transform = `rotate(${-angle}deg)`;
							transformOrigin = '100% 100%';
							break;
						case 'bottom-right':
						default:
							// 从左上到右下（默认）
							transform = `rotate(${angle}deg)`;
							transformOrigin = '0 0';
							break;
					}
					let weiz = direction == 'bottom-left' ? 'top: 0;' : direction == 'bottom-right' ?
						'top: 0;' : 'bottom: 0;'
					let weizLeft = direction == 'bottom-left' ? 'left: -5px;' : direction == 'bottom-right' ?
						'left: 0;' : 'left: 0;'
					// 添加伪元素样式
					const uniqueClass = `diagonal-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
					element.classList.add(uniqueClass);
					styleElement.textContent = `
                            .${uniqueClass}::before {
                            content: '';
                            position: absolute;
                            width: ${diagonalLength}px;
                            height: 1px;
                            background-color: #2b2e33;
                            ${weiz}
                            ${weizLeft}
                            transform: ${transform};
                            transform-origin: ${transformOrigin};
                            z-index: 1;
                            }
                        `;
					element.appendChild(styleElement);
				});
			}

		}
	}
</script>

<style scoped lang="less">
	.excelBox {
		margin: 0 auto;
		height: 100%;
		border-top: 2px solid #43464d;
	}

	.table_AgKOv {
		margin-top: -1px;
		border-left: 2px solid #2b2e33;
		border-right: 2px solid #2b2e33;
		border-bottom: 2px solid #2b2e33;
		table-layout: fixed;
		width: 100%;
		height: 100%;
		/* 添加这一行 */
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	.table_AgKOv td,
	.table_AgKOv tr {
		border: 1px solid #2b2e33;
		position: relative;
	}

	.table_AgKOv td {
		height: 40px;
		line-height: 1.5;
		padding: 0 10px;
		text-align: center;
		vertical-align: middle;
		color: #2b2e33;
		box-sizing: border-box;
		/* 确保padding不会影响宽度计算 */
	}

	.table_AgKOv .value_1DtKU {
		text-align: center;
	}

	.label_3bK48 {
		font-weight: 700;
	}

	.value_1DtKU {
		text-align: center;
	}


	table th {
		font-weight: 700;
	}


	table td,
	table th {
		height: 38px;
		padding: 8px 12px;
		font-size: 16px;
		vertical-align: middle;
		word-break: break-all;
		border: 1px solid #495060;
	}


	table {
		width: 100%;
		border-color: #495060;
		border-style: solid;
		border-width: 1px 2px;
		border-collapse: collapse;
	}


	.table_AgKOv td[colspan="1"] {
		width: var(--cow--width);
	}

	.table_AgKOv td[colspan="1.5"] {
		width: calc(var(--cow--width) * 1.5);
	}

	.table_AgKOv td[colspan="2"] {
		width: calc(var(--cow--width) * 2);
	}

	.table_AgKOv td[colspan="3"] {
		width: calc(var(--cow--width) * 3);
	}

	.table_AgKOv td[colspan="4"] {
		width: calc(var(--cow--width) * 4);
	}

	.table_AgKOv td[colspan="5"] {
		width: calc(var(--cow--width) * 5);
	}

	.table_AgKOv td[colspan="6"] {
		width: calc(var(--cow--width) * 6);
	}

	.table_AgKOv td[colspan="7"] {
		width: calc(var(--cow--width) * 7);
	}

	.table_AgKOv td[colspan="8"] {
		width: calc(var(--cow--width) * 8);
	}

	.table_AgKOv td[colspan="9"] {
		width: calc(var(--cow--width) * 9);
	}

	.table_AgKOv td[colspan="10"] {
		width: calc(var(--cow--width) * 10);
	}

	.table_AgKOv td[colspan="11"] {
		width: calc(var(--cow--width) * 11);
	}

	.table_AgKOv td[colspan="12"] {
		width: calc(var(--cow--width) * 12);
	}

	.table_AgKOv td[colspan="13"] {
		width: calc(var(--cow--width) * 13);
	}

	.table_AgKOv td[colspan="14"] {
		width: calc(var(--cow--width) * 14);
	}

	.table_AgKOv td[colspan="15"] {
		width: calc(var(--cow--width) * 15);
	}

	.table_AgKOv td[colspan="16"] {
		width: calc(var(--cow--width) * 16);
	}

	.table_AgKOv td[colspan="17"] {
		width: calc(var(--cow--width) * 17);
	}

	.table_AgKOv td[colspan="18"] {
		width: calc(var(--cow--width) * 18);
	}

	.table_AgKOv td[colspan="19"] {
		width: calc(var(--cow--width) * 19);
	}

	.table_AgKOv td[colspan="20"] {
		width: calc(var(--cow--width) * 20);
	}

	.table_AgKOv td[colspan="21"] {
		width: calc(var(--cow--width) * 21);
	}

	.table_AgKOv td[colspan="22"] {
		width: calc(var(--cow--width) * 22);
	}

	.table_AgKOv td[colspan="23"] {
		width: calc(var(--cow--width) * 23);
	}

	.table_AgKOv td[colspan="24"] {
		width: calc(var(--cow--width) * 24);
	}


	.select_1DtKU {
		position: relative;

		img {
			width: 30px;
			height: 30px;
			position: absolute;
			right: -35px;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	.select_box {
		.s_b_box {
			margin-bottom: 5px;
			width: 100%;

			.ant-select {
				width: 100%;
			}
		}

		.s_b_box:last-of-type {
			margin-bottom: 0;
		}
	}

	.ant-form-item {
		margin-bottom: 0;


		::v-deep .ant-col {
			.ant-form-explain {
				display: none;
			}
		}

		.ant-calendar-picker {
			width: 100%;
		}

		::v-deep .ant-select {
			.ant-select-selection__rendered {
				margin-right: 0 !important;
			}
		}
	}


	.flex_200 {
		display: flex;
		align-items: center;

		.ant-input {
			width: 200px;
		}

		.ant-calendar-picker {
			width: 200px;
		}
	}

	.ant-input-number {
		width: 100%;
	}

	.nested-table-cell {

		.nested-table-wrapper {
			width: 100%;
			height: 100%;
			// overflow: hidden;
			width: 100%; // 补偿左右各2px的边框
			position: relative;
			left: -1px;
		}

		::v-deep .excelBox {
			border-top: 0;
		}

		::v-deep .table_AgKOv {
			table-layout: auto !important;
			width: 100% !important;
			height: 100% !important;
			margin: 0 !important;
			// 移除内嵌表格的最外层边框
			border: none !important;

			td {
				// padding: 0 10px !important;
				box-sizing: border-box;
			}

			// 第一排最左边td：去除上边框和左边框
			>tr {
				border-top: none !important;
				border-left: none !important;
			}

			>tr>td:first-child {
				border-top: none !important;
				border-left: none !important;
			}

			// 第一排中间td：去除上边框
			>tr:first-child>td:not(:first-child):not(:last-child) {
				border-top: none !important;
				border-right: none !important;
			}

			// 第一排最右边td：去除上边框和右边框
			>tr:first-child {
				border-top: none !important;
				border-right: none !important;
			}

			>tr:first-child>td:last-child {
				border-top: none !important;
				border-right: none !important;
			}

			// 最后一排最左边td：去除下边框和左边框
			>tr:last-child> {
				border-bottom: none !important;
				border-left: none !important;
			}

			>tr:last-child>td:first-child {
				border-bottom: none !important;
				border-left: none !important;
			}

			// 最后一排中间td：去除下边框
			>tr>td:not(:first-child):not(:last-child) {
				border-bottom: none !important;
				border-right: none !important;
			}

			// 最后一排中间td：去除下边框
			>tr:last-child>td:not(:first-child):not(:last-child) {
				border-bottom: none !important;
				border-right: none !important;
			}

			// 最后一排最右边td：去除下边框和右边框
			>tr {
				border-bottom: none !important;
				border-right: none !important;
			}

			>tr>td:last-child {
				border-bottom: none !important;
				border-right: none !important;
			}

			// 保留其他内部单元格的边框
			td {
				border: 1px solid #2b2e33 !important;
			}
		}
	}

	.add_row_box {
		position: absolute;
		display: flex;
		align-items: center;
		gap: 12px;
		top: 50%;
		transform: translate(100%, -50%);
		right: -25px;

		img {
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}

	.diagonal-cell {
		position: relative;
		overflow: hidden;
		padding: 0 !important;

		.diagonal-wrapper {
			position: relative;
			width: 100%;
			height: 100%;
		}

		.diagonal-content {
			position: relative;
			width: 100%;
			height: 100%;

			.diagonal-text {
				position: absolute;
				z-index: 2;
				font-size: 14px;
				line-height: 1.2;

				&.topLeft {
					top: 2px;
					left: 2px;
					right: 50%;
					bottom: 50%;
					display: flex;
					align-items: flex-start;
					justify-content: flex-start;
					padding: 2px;
				}

				&.bottomRight {
					top: 50%;
					left: 50%;
					right: 2px;
					bottom: 2px;
					display: flex;
					align-items: flex-end;
					justify-content: flex-end;
					padding: 2px;
				}

			}

		}

		.bottom-right {
			.topLeft {
				top: 50% !important;
				left: 2px;
				right: 50%;
				bottom: 2px !important;
				display: flex;
				align-items: flex-start;
				justify-content: flex-start;
				padding: 2px;
			}

			.bottomRight {
				top: 2px !important;
				left: 50%;
				right: 2px;
				bottom: 50% !important;
				display: flex;
				align-items: flex-end;
				justify-content: flex-end;
				padding: 2px;
			}
		}
	}

	.radio_square {
		::v-deep .ant-radio-inner {
			border-radius: 0;

			&::after {
				border-radius: 0;
			}
		}
	}


	.value_1DtKU {
		::v-deep .ant-form-item-children {
			display: flex;
		}
	}
</style>